<template xmlns="http://www.w3.org/1999/html">
  <b-container id="annonce-add-boost-container" class="d-flex flex-column">
    <div id="annonce-add-boost-title-container" class="row pt-md-3 pt-2">
      <div class="col-12 col-md-6 d-flex justify-content-center">
        <div class="custom-width ml-md-5 justify-content-between d-md-flex align-items-center">
          <back-arrow :title="$t('boost.page.title')"/>
        </div>
      </div>
    </div>

    <div id="annonce-add-boost-sub-container" class="row pt-md-5 pt-2">
      <div id="annonce-add-boost-sub-container-left" class="col-12 col-md-6 col-title">
        <div class="custom-width ml-md-5 mt-3">
          <span class="bold-text">{{ $t('boost.page.subtitle') }}</span>
        </div>
        <div class="custom-width ml-md-5 mt-3">
          <h1 class="content">{{ $t('boost.page.description') }}</h1>
        </div>
      </div>

      <div id="annonce-add-boost-sub-container-right"
           class="col-12 col-md-6 d-flex justify-content-center justify-content-md-start">

        <div
          class="row col-12 col-md-8 d-flex justify-content-center justify-content-md-start pl-md-0 mt-3 mt-md-0 pr-under-md-0 pl-under-md-0">
          <div class="col-12 pl-0 pr-0 mb-1">
            <div class=" styled-scrollbar-custom">
              <!--          region fake card-->
              <div class="fake-card-container mb-4">
                <div class="fake-card-image-container">
                  <img :src="require(`@/assets/images/b122/fakeAnnonceImage.jpeg`)" alt="Veilleur"
                       class="fake-card-image">
                  <div class="boost-icon-container fake-card-boost-icon-container">
                    <i class="ph-lightning-fill"></i>
                  </div>
                </div>
                <div class="fake-card-values">
                  <div>
                    <div class="fake-card-title w-75"></div>
                    <div class="fake-card-title w-50"></div>
                    <div class="fake-card-content w-25 mt-2"></div>
                    <div class="fake-card-content w-50"></div>
                  </div>
                  <div class="fake-card-views"></div>
                </div>
              </div>
              <!--          endregion-->

              <div v-for="[key, value] of Object.entries(options)"
                   :key="key"
                   class="reward-boost-option-container mt-2">
                <div class="d-flex flex-row">
                  <b-form-radio
                    v-model="selectedOption"
                    :value="value"
                  ></b-form-radio>
                  <div>{{ key + " " + (key > 1 ? $t('weeks') : $t('week')) }}</div>
                </div>
                <div class="reward-boost-option-price">
                  {{ value.price + "€" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-annonce-add-boost">
      <div class="row h-100">
        <div class="col-md-12  d-flex align-items-center mb-2 ml-2 mr-2 justify-content-around">
          <div class="hide"></div>
          <b-button
            v-if="!hasPaid"
            :disabled="selectedOption === null"
            class="mr-1"
            variant="primary"
            @click="validate"
          >
            <div v-if="!isLoading" class="pr-4 pl-4">
              {{ $t('Validate') }}
            </div>
            <b-spinner v-else class="button-spinner"></b-spinner>
          </b-button>
        </div>
      </div>
    </div>


    <StripePaymentModal
      :client-secret="stripeClientSecret"
      :total="this.totalToPay"
      :is-instant-payment="true"
      redirect-url="/annonce/validateBoostStripeIntent"
      @closedStripePaymentModal="closedStripePaymentModal"
      @validatePayment="handlePostPaymentSuccess"
    ></StripePaymentModal>

  </b-container>


</template>

<script>
import BackArrow from "../../components/b122/BackArrow";
import api from "../../services/api";
import StripePaymentModal from "../../components/annonce/StripePaymentModal";

export default {
  name: "AnnonceBoostEdit",

  components: {
    BackArrow,
    StripePaymentModal,
  },

  data() {
    return {
      annonceId: this.$route.params.annonceId,
      isLoading: false,

      selectedOption: null,

      options:{
        1: {
          index: 1,
          price: 7.99,
        },
        2: {
          index: 2,
          price: 14.99,
        },
        3: {
          index: 3,
          price: 19.99,
        },
      },

      hasPaid: false,
      totalToPay: 0,
      stripeIntentId: "",
      stripeClientSecret: "",
    }
  },

  methods: {

    validate(){
      if(this.selectedOption !== null){
        this.totalToPay = this.selectedOption.price
        this.requestStripePaymentIntent()
      }
    },

    async requestStripePaymentIntent() {
      let formData = new FormData()
      formData.append('boostAmount', this.totalToPay)

      api({
        method: 'POST',
        url: `/annonce/createBoostStripeIntent`,
        data: formData
      })
        .then((response) => {
          this.stripeIntentId = response.data.paymentIntentId
          this.stripeClientSecret = response.data.paymentIntentSecret
          this.$nextTick(()=>{
            this.$bvModal.show('StripePaymentModal')
          })
        })
        .catch((error) => {
          this.handleError()
        })
    },

    closedStripePaymentModal(){
      this.isLoading = false
    },

    handlePostPaymentSuccess(){
      this.hasPaid = true

      let boostEndDate = (Date.now() + (this.selectedOption.index * 1000 * 60 * 60 * 24 * 7));

      let data = new FormData()
      data.append('paymentIntentId', this.stripeIntentId)
      data.append('annonceId', this.annonceId)
      data.append('boostDuration', this.selectedOption.index)
      data.append('boostEndDate', boostEndDate)

      api({
        method: "POST",
        url: `/annonce/validateBoostStripeIntent`,
        data: data
      })
        .then((response)=>{
          if(response.data === true){
            this.successToast()
            setTimeout(() => {this.$router.back()}, 2000)
          }else{
            this.handleError()
          }
        })
        .catch((error)=>{
          this.handleError()
        })
    },

    handleError(){
      this.isLoading = false
      this.hasPaid = false
      this.errorToast()
    },

    successToast () {
      this.$bvToast.toast(this.$i18n.t('transaction.success'), {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        variant: 'success',
        title: this.$i18n.t('Success'),
      })
    },

    errorToast () {
      this.$bvToast.toast(this.$i18n.t('Error'), {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        variant: 'error',
        title: this.$i18n.t('Error.title'),
      })
    },
  }
}
</script>

<style scoped>
/* pour affichage desktop (md) : scroll pas sur la page entière mais sur le contenu modifiable uniquement */
@media (min-width: 769px) {

  #annonce-add-boost-container {
    height: calc(89vh - 100px);
    max-height: calc(89vh - 100px);
  }

  #annonce-add-boost-title-container {
    height: 100px;
  }

  #annonce-add-boost-sub-container {
    height: calc(100% - 100px);
  }

  #annonce-add-boost-sub-container-right {
    height: 100%;
  }
}

@media (max-width: 768px) {
  #annonce-add-boost-sub-container-right {
    margin-bottom: 100px;
  }
}

.custom-width {
  width: 50%;
}

.col-title {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-annonce-add-boost {
  background-color: var(--main-black-dark);
  position: fixed;
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 100px;
  z-index: 10;
}

.button-spinner.spinner-border {
  margin-left: calc(1.5rem + 28px - 0.5rem);
  margin-right: calc(1.5rem + 28px - 0.5rem);
}

@media (max-width: 768px) {

  .custom-width {
    width: 100%;
  }

  .col-title {
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    justify-content: flex-start;
    align-items: flex-start;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/annonce/AnnonceBoostEdit.vue